module.exports = __webpack_public_path__ + "img/patent.0d2bee73.svg";